var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h

  return _c(
    "div",
    [
      _c("gg-modal", {
        attrs: {
          "is-active": _vm.isShow
        },
        on: {
          close: _vm.closeModal
        },
        scopedSlots: _vm._u([
          {
            key: "toolbar",
            fn: function fn() {
              return [_vm._v(" Renewal Options for Your Hosting Plan ")]
            },
            proxy: true
          },
          {
            key: "body",
            fn: function fn() {
              return [
                _vm.renewalLoadError
                  ? _c(
                      "v-card-text",
                      [
                        _c(
                          "v-row",
                          [
                            _c(
                              "v-col",
                              {
                                staticClass: "d-flex flex-column align-center",
                                attrs: {
                                  cols: "12"
                                }
                              },
                              [
                                _c(
                                  "v-icon",
                                  {
                                    attrs: {
                                      color: "error",
                                      size: "64"
                                    }
                                  },
                                  [_vm._v("mdi-close-circle")]
                                ),
                                _c(
                                  "h4",
                                  {
                                    staticClass: "mt-3 text-center"
                                  },
                                  [
                                    _vm._v(
                                      "There was a problem loading your renewal options."
                                    )
                                  ]
                                ),
                                _vm.renewalLoadErrorMessage
                                  ? _c(
                                      "h4",
                                      {
                                        staticClass:
                                          "mt-2 text-center red--text font-weight-bold"
                                      },
                                      [
                                        _vm._v(
                                          " " +
                                            _vm._s(
                                              _vm.renewalLoadErrorMessage
                                            ) +
                                            " "
                                        )
                                      ]
                                    )
                                  : _vm._e(),
                                _c(
                                  "h4",
                                  {
                                    staticClass: "mt-2 text-center"
                                  },
                                  [_vm._v("Please contact us for assistance.")]
                                )
                              ],
                              1
                            )
                          ],
                          1
                        )
                      ],
                      1
                    )
                  : _vm.loadingRenewalPricing
                  ? _c(
                      "v-card-text",
                      [
                        _c(
                          "v-row",
                          [
                            _c(
                              "v-col",
                              {
                                staticClass:
                                  "d-flex flex-column align-center justify-center py-8",
                                attrs: {
                                  cols: "12"
                                }
                              },
                              [
                                _c("v-progress-circular", {
                                  attrs: {
                                    indeterminate: "",
                                    color: "primary",
                                    size: "62"
                                  }
                                }),
                                _c(
                                  "p",
                                  {
                                    staticClass: "mt-4 mb-0 grey--text"
                                  },
                                  [_vm._v("Loading renewal options...")]
                                )
                              ],
                              1
                            )
                          ],
                          1
                        )
                      ],
                      1
                    )
                  : !_vm.renewCompleted
                  ? _c(
                      "v-card-text",
                      [
                        _c(
                          "v-row",
                          [
                            _c(
                              "v-col",
                              {
                                attrs: {
                                  cols: "12"
                                }
                              },
                              [
                                _c(
                                  "p",
                                  {
                                    staticClass: "mb-0"
                                  },
                                  [
                                    _vm._v(
                                      " Your current plan renews on " +
                                        _vm._s(
                                          new Date(
                                            _vm.currentService.renewaldate
                                          ).toLocaleDateString("en-CA", {
                                            year: "numeric",
                                            month: "long",
                                            day: "numeric"
                                          })
                                        ) +
                                        ". Choose a term below to lock in savings and avoid price increases. "
                                    )
                                  ]
                                )
                              ]
                            )
                          ],
                          1
                        ),
                        _c(
                          "v-row",
                          [
                            _c(
                              "v-col",
                              {
                                attrs: {
                                  cols: "12"
                                }
                              },
                              [
                                _c("h5", [_vm._v("Your Current Plan")]),
                                _vm._v(
                                  " " +
                                    _vm._s(_vm.currentService.name) +
                                    " - " +
                                    _vm._s(_vm.currentCost) +
                                    " "
                                )
                              ]
                            )
                          ],
                          1
                        ),
                        _c(
                          "v-row",
                          [
                            _c(
                              "v-col",
                              {
                                attrs: {
                                  cols: "12"
                                }
                              },
                              [
                                _c("h5", [_vm._v("Choose Your Renewal Term:")]),
                                _c(
                                  "v-radio-group",
                                  {
                                    staticClass: "mt-1 pt-0",
                                    model: {
                                      value: _vm.selectedPeriod,
                                      callback: function callback($$v) {
                                        _vm.selectedPeriod = $$v
                                      },
                                      expression: "selectedPeriod"
                                    }
                                  },
                                  _vm._l(_vm.renewalPricing, function(
                                    priceDetails,
                                    planName
                                  ) {
                                    return _c(
                                      "v-row",
                                      {
                                        key: planName,
                                        staticClass: "my-2 py-0"
                                      },
                                      [
                                        _c(
                                          "v-col",
                                          {
                                            staticClass: "my-0 py-0",
                                            class:
                                              planName === _vm.selectedPeriod
                                                ? "active"
                                                : "",
                                            staticStyle: {
                                              border: "1px solid grey",
                                              "border-radius": "24px"
                                            },
                                            attrs: {
                                              cols: "12"
                                            }
                                          },
                                          [
                                            _c("v-radio", {
                                              staticClass: "py-0 my-3",
                                              attrs: {
                                                value: planName
                                              },
                                              scopedSlots: _vm._u(
                                                [
                                                  {
                                                    key: "label",
                                                    fn: function fn() {
                                                      return [
                                                        _c(
                                                          "v-row",
                                                          [
                                                            _c(
                                                              "v-col",
                                                              {
                                                                staticClass:
                                                                  "text-capitalize",
                                                                attrs: {
                                                                  cols: "6"
                                                                }
                                                              },
                                                              [
                                                                _vm._v(
                                                                  " " +
                                                                    _vm._s(
                                                                      planName
                                                                    ) +
                                                                    " "
                                                                ),
                                                                _vm.bestDealPlanName ===
                                                                planName
                                                                  ? _c(
                                                                      "v-chip",
                                                                      {
                                                                        staticClass:
                                                                          "mb-0 ml-1",
                                                                        attrs: {
                                                                          small:
                                                                            "",
                                                                          color:
                                                                            "primary"
                                                                        }
                                                                      },
                                                                      [
                                                                        _vm._v(
                                                                          "Best Deal"
                                                                        )
                                                                      ]
                                                                    )
                                                                  : _vm._e()
                                                              ],
                                                              1
                                                            ),
                                                            _c(
                                                              "v-col",
                                                              {
                                                                staticClass:
                                                                  "text-right",
                                                                attrs: {
                                                                  cols: "6"
                                                                }
                                                              },
                                                              [
                                                                _c(
                                                                  "span",
                                                                  {
                                                                    directives: [
                                                                      {
                                                                        name:
                                                                          "show",
                                                                        rawName:
                                                                          "v-show",
                                                                        value:
                                                                          priceDetails.has_discount,
                                                                        expression:
                                                                          "priceDetails.has_discount"
                                                                      }
                                                                    ],
                                                                    staticClass:
                                                                      "primary--text mr-1"
                                                                  },
                                                                  [
                                                                    _c(
                                                                      "strong",
                                                                      [
                                                                        _vm._v(
                                                                          "Save " +
                                                                            _vm._s(
                                                                              priceDetails.discount_percent
                                                                            ) +
                                                                            "%"
                                                                        )
                                                                      ]
                                                                    ),
                                                                    _vm._v(
                                                                      " - "
                                                                    )
                                                                  ]
                                                                ),
                                                                _c(
                                                                  "span",
                                                                  {
                                                                    directives: [
                                                                      {
                                                                        name:
                                                                          "show",
                                                                        rawName:
                                                                          "v-show",
                                                                        value:
                                                                          priceDetails.has_discount,
                                                                        expression:
                                                                          "priceDetails.has_discount"
                                                                      }
                                                                    ],
                                                                    staticClass:
                                                                      "grey--text text--darken-2 text-decoration-line-through mr-1",
                                                                    staticStyle: {
                                                                      "font-size":
                                                                        "0.85rem"
                                                                    }
                                                                  },
                                                                  [
                                                                    _vm._v(
                                                                      " $" +
                                                                        _vm._s(
                                                                          parseFloat(
                                                                            priceDetails.standard_cost
                                                                          ).toFixed(
                                                                            2
                                                                          )
                                                                        ) +
                                                                        " "
                                                                    )
                                                                  ]
                                                                ),
                                                                _c(
                                                                  "span",
                                                                  {
                                                                    staticClass:
                                                                      "mr-1"
                                                                  },
                                                                  [
                                                                    _vm._v(
                                                                      "$" +
                                                                        _vm._s(
                                                                          parseFloat(
                                                                            priceDetails.total
                                                                          ).toFixed(
                                                                            2
                                                                          )
                                                                        )
                                                                    )
                                                                  ]
                                                                )
                                                              ]
                                                            )
                                                          ],
                                                          1
                                                        )
                                                      ]
                                                    },
                                                    proxy: true
                                                  }
                                                ],
                                                null,
                                                true
                                              )
                                            })
                                          ],
                                          1
                                        )
                                      ],
                                      1
                                    )
                                  }),
                                  1
                                )
                              ],
                              1
                            )
                          ],
                          1
                        ),
                        _c(
                          "v-row",
                          [
                            _c(
                              "v-col",
                              {
                                staticClass: "pb-0 pt-5 d-flex flex-column",
                                attrs: {
                                  cols: "12"
                                }
                              },
                              [
                                _c("h5", [_vm._v("Payment Method")]),
                                _vm.errorMessage
                                  ? _c(
                                      "strong",
                                      {
                                        staticClass: "red--text pb-1"
                                      },
                                      [_vm._v(_vm._s(_vm.errorMessage))]
                                    )
                                  : _vm._e()
                              ]
                            ),
                            _c(
                              "v-col",
                              {
                                staticClass: "py-1",
                                attrs: {
                                  cols: "12"
                                }
                              },
                              [
                                _c("payment-gateway", {
                                  ref: "paymentGateway",
                                  attrs: {
                                    compact: true
                                  },
                                  on: {
                                    gateway: _vm.listenGateway,
                                    card: _vm.listenCard,
                                    "card-switch": _vm.listenCardNew
                                  }
                                }),
                                _vm.paymentGateway === "paypal"
                                  ? _c(
                                      "form",
                                      {
                                        ref: "frm_paypal",
                                        staticStyle: {
                                          display: "none"
                                        },
                                        attrs: {
                                          method: "post"
                                        }
                                      },
                                      [
                                        _c("input", {
                                          attrs: {
                                            type: "hidden",
                                            name: "cmd",
                                            value: "_s-xclick"
                                          }
                                        }),
                                        _c("input", {
                                          ref: "paypal_encrypted",
                                          attrs: {
                                            type: "text",
                                            name: "encrypted"
                                          }
                                        }),
                                        _c("input", {
                                          attrs: {
                                            type: "submit",
                                            value: ""
                                          }
                                        })
                                      ]
                                    )
                                  : _vm._e()
                              ],
                              1
                            )
                          ],
                          1
                        )
                      ],
                      1
                    )
                  : _c(
                      "v-card-text",
                      [
                        _c(
                          "v-row",
                          [
                            _c(
                              "v-col",
                              {
                                staticClass: "d-flex flex-column align-center",
                                attrs: {
                                  cols: "12"
                                }
                              },
                              [
                                _c(
                                  "v-icon",
                                  {
                                    attrs: {
                                      color: "green",
                                      size: "64"
                                    }
                                  },
                                  [_vm._v("mdi-check-circle")]
                                ),
                                _c(
                                  "h4",
                                  {
                                    staticClass: "mt-3"
                                  },
                                  [
                                    _vm._v(
                                      "It's done, you're all set! Thank you for your business!"
                                    )
                                  ]
                                ),
                                _c("h4", [
                                  _vm._v("You saved a total of "),
                                  _c(
                                    "span",
                                    {
                                      staticClass: "font-bold primary--text"
                                    },
                                    [
                                      _vm._v(
                                        "$" + _vm._s(_vm.totalSavedFormatted)
                                      )
                                    ]
                                  ),
                                  _vm._v(" today by renewing early.")
                                ]),
                                _c("h4", [
                                  _vm._v(
                                    "Your next renewal date is on " +
                                      _vm._s(_vm.nextDueDate) +
                                      "."
                                  )
                                ]),
                                _c(
                                  "gg-btn",
                                  {
                                    attrs: {
                                      primary: ""
                                    },
                                    on: {
                                      click: _vm.closeModalAfterRenewal
                                    }
                                  },
                                  [_vm._v("Go Back")]
                                )
                              ],
                              1
                            )
                          ],
                          1
                        )
                      ],
                      1
                    )
              ]
            },
            proxy: true
          },
          {
            key: "actions",
            fn: function fn() {
              return [
                _vm.loadingRenewalPricing
                  ? void 0
                  : _vm.renewalLoadError
                  ? [
                      _c(
                        "gg-btn",
                        {
                          staticStyle: {
                            "text-transform": "none !important"
                          },
                          on: {
                            click: _vm.handleStartChat
                          }
                        },
                        [_vm._v("Start a Chat")]
                      ),
                      _c(
                        "gg-btn",
                        {
                          staticStyle: {
                            "text-transform": "none !important"
                          },
                          attrs: {
                            primary: ""
                          },
                          on: {
                            click: _vm.handleOpenTicket
                          }
                        },
                        [_vm._v("Open a Ticket")]
                      ),
                      _c(
                        "gg-btn",
                        {
                          attrs: {
                            secondary: ""
                          },
                          on: {
                            click: _vm.closeModal
                          }
                        },
                        [_vm._v("Cancel")]
                      )
                    ]
                  : !_vm.renewCompleted
                  ? [
                      _c(
                        "gg-btn",
                        {
                          attrs: {
                            secondary: ""
                          },
                          on: {
                            click: _vm.closeModal
                          }
                        },
                        [_vm._v("Cancel")]
                      ),
                      _c(
                        "gg-btn",
                        {
                          attrs: {
                            loading: _vm.loading,
                            disabled: !_vm.isPaymentFormReady
                          },
                          on: {
                            click: _vm.submitRenew
                          }
                        },
                        [_vm._v("Renew Now")]
                      )
                    ]
                  : _vm._e()
              ]
            },
            proxy: true
          }
        ])
      }),
      _c("auto-renew-modal", {
        ref: "autoRenewModal"
      }),
      _c("show-invoice-modal", {
        ref: "showInvoiceModal",
        attrs: {
          "invoice-id": _vm.invoiceId,
          title: "Proceed to invoice"
        }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }